import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';

export default function RecipientCopyrightTransferFormView1({
  document,
  karaokeOrder,
  onNext,
} : {
  document: string,
  karaokeOrder: {
    applicant_name: string,
    applicant_address: string,
  },
  onNext: () => void,

}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);

  return (
    <>
      <h2>
        印税を受け取るための
        <br />
        著作権手続きについて
      </h2>
      <div className="figure">
        <div className="figure__inner">
          <img src="/img/karaoke_service/copyright_pt2.png" alt="著作権の手続き" />
        </div>
      </div>
      <p className="mb50">下記の契約書をお読みいただき、契約内容への同意をお願いします。</p>
      <br />
      <h2 className="m0">※重要</h2>
      <ul className="important">
        <li>
          ・この曲があなた自身の曲であるか、この曲の著作権の全てがあなたに譲渡されている場合のみ契約することができます。
          万が一他者からこの曲の著作権について申し立てがあった場合、ワールドスケープでは一切の責任を負うことができません。
        </li>
        <li>・今後も、この曲の演奏や配信・CD製作などはあなたが自由に行えます。</li>
        <li>・この曲の著作権を、あなたが他者に譲渡したり信託したりすることはできなくなります。</li>
        <li>・発生した印税はFrekulの「Frekul残高」に記録されます。</li>
        <li>・締結後、この契約書はWEB上であなたと株式会社ワールドスケープが閲覧できる状態になります。</li>
      </ul>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: document }} />
      <div className="loader_parts_container">
        <form className="cake_ajax_form">
          <div className="form__body">
            <dl>
              <dd>
                <ul className="col" style={{ float: 'none' }}>
                  <li className="col span_24">
                    <span className="col span_6">あなたの本名:</span>
                    <span className="col span_18">{karaokeOrder.applicant_name}</span>
                  </li>
                  <li className="col span_24">
                    <span className="col span_6">
                      住所
                      <span className="asterisk">※</span>
                    </span>
                    <span className="col span_18">
                      {karaokeOrder.applicant_address}
                    </span>
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <CustomCheckbox
                checked={agreement1}
                setChecked={(checked) => setAgreement1(checked)}
              >
                契約内容に同意します。
              </CustomCheckbox>
              <CustomCheckbox
                checked={agreement2}
                setChecked={(checked) => setAgreement2(checked)}
              >
                <a href="/privacy" target="_blank">個人情報保護方針</a>
                に同意します。
              </CustomCheckbox>
            </dl>
            <ul>
              <li className="bt">
                <CustomButton type="default" disabled={!(agreement1 && agreement2)} onClick={() => onNext()}>次へ</CustomButton>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </>
  );
}
